<template>
    <div v-if="errors.length > 0" class="my-4">
        <div class="font-medium text-red-600">{{ $t('Whoops! Something went wrong.') }}</div>
        <ul class="mt-3 list-disc list-inside text-sm text-red-600">
            <li v-for="error in errors" :key="error" class="text-red-600">{{ $t(error) }}</li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'ValidationErrors',
    props: {
        errors: Array,
    },
}
</script>
